import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import Seo from "../../components/Seo/Seo";
import site from "../../data/site";
import { aboutGraph } from "../../seo/schema";
import classes from "./About.module.css";

export default function AboutPage() {
  return (
    <main className="page">
      <Seo
        title={site.about.title}
        description={site.about.description}
        path="/about"
        jsonLd={aboutGraph()}
      />
      <article className={classes.page}>
        <Container>
          <div className={classes.grid}>
            <div className={classes.media}>
              <img
                src={site.about.image}
                alt={site.about.imageAlt}
                width={site.about.width}
                height={site.about.height}
                decoding="async"
              />
            </div>
            <div className={classes.copy}>
              <div className="sectionEyebrow">About</div>
              <h1 className="sectionTitle">About DigitaliNation</h1>
              <p>
                DigitaliNation is a fully remote software and marketing studio
                based in Islamabad, Pakistan. Founded by {site.founder}, we
                work with clients worldwide from a team that does not need a
                shared office to ship.
              </p>
              <p>
                We pair engineering with growth work so a business gets more
                than a deliverable. Websites, mobile apps, social, email,
                design, AI automations, GoHighLevel, and virtual assistance
                are scoped to the problem in front of you, and we stay until
                the numbers move.
              </p>
              <p>
                There is no public street address. The studio is remote, and
                the best next step is a call or an email.
              </p>
              <div className={classes.contact}>
                <a href={`tel:${site.phone}`}>{site.phoneDisplay}</a>
                <a href={`mailto:${site.email}`}>{site.email}</a>
                <Link to="/services">See services</Link>
              </div>
            </div>
          </div>
        </Container>
      </article>
      <Footer />
    </main>
  );
}
